const API_LIST = {
  API_ROUTES: {
    BASE_PATH: "api/webapi",
    LOGIN: "api/webapi",
    GET_MODULES_LIST_NIIT_ADMIN: "api/getmodulesapi",
    DYNAMIC_BANNER: "api/splash-banner",
    ASSIGN_COURSE: "api/assigncourseapi",
    MODULE_FAV: "api/webapi",
    MODULE_FAV_DEL: "api/webapi",
    MODULE_NOTES: "api/webapi",
    MODULE_NOTES_UPDATE: "api/webapi",
    MODULE_NOTES_DEL: "api/webapi",
    ROLE_PLAY: "api/roleplay",
    ROLEPLAY_MASTER_LIST: "meeting/ajax_roleplay?module=getRoleplayList",
  },
  API_ROUTES_BROKER: {
    GROUPS_FILTER: "/wp-json/xsel/v1/get-group-listing",
    RESCHEDULE_SLOTS: "/wp-json/coaching/coaching-request-save",
    AJAX_BASE_PATH: "/wp-admin/admin-ajax.php",

    VERIFY_SIGNUP_PATH: "/wp-json/xsel/v1/verify-signup-token",
    RESEND_SIGNUP_PATH: "/wp-json/xsel/v1/resend-signup-token",
    FORGOT_PASSWORD_LINK_PATH: "/wp-json/xsel/v1/realtor-forgot-password",

    BANNER_CARD_SUMMARY: "/wp-json/xsel/v1/banner-card-summary",

    LOGIN_BASE_PATH: "/wp-json/xsel/v1/login",
    LOGIN_BASE_PATH_GOOGLE: "/wp-json/xsel/v1/google-auth-signin",
    LOGIN_BASE_PATH_SSO: "/wp-json/sso/saml-authentication",
    LOGIN_HOSTINST_BASE_PATH: "/wp-json/xsel/v1/host-instructor-login",
    UPDATE_PASSWORD_BASE_PATH: "/wp-json/xsel/v1/realtor-update-password",
    USER_DETAIL_PROFILE: "/wp-json/xsel/v1/profile",
    USER_DETAIL_PROFILE_FOR_OTHER: "/wp-json/xsel/v1/user-profile-by-manager",
    PROFILE_COMPLETE_DATA: "/wp-json/xsel/v1/get-profile-complete-data",
    LOGOUT_BASE_PATH: "/wp-json/broker/logout",

    GET_COURSES_BROKER: "/wp-json/xsel/v1/get_all_courses",
    COURSE_DETAIL_BASE_PATH: "/wp-json/products/single-shopping/",
    PRODUCT_CATEGORY_BASE_PATH:
      "/wp-json/categories/product-categories/?brokerage_id=",

    ADD_TO_CART_BASE_PATH: "/wp-json/customers/add-to-cart/",
    MY_CART_BASE_PATH: "/wp-json/cart/my-cart",
    MY_CART_DEL_BASE_PATH: "/wp-json/cart/remove-product/",
    SAVE_LATER_BASE_PATH: "/wp-json/cart/save-later",
    SAVE_LATER_VIEW_BASE_PATH: "/wp-json/cart/show-save-later",
    DELETE_SAVE_LATER_BASE_PATH: "/wp-json/cart/delete-save-later",

    PAYMENT_CHECKOUT: "/wp-json/checkout/user",
    PAYMENT_BASE_PATH: "/wp-json/stripe/payment-intents/",
    DIRECT_CHECKOUT_PATH: "/wp-json/buynow/response",
    PAYMENT_USER_BASE_PATH: "/wp-json/wocommerce/user",
    SEND_ORDER_PLACE_BASE_PATH: "/wp-json/checkout-response/response",
    ZERO_ORDER_PLACE_BASE_PATH:
      "/wp-json/checkout-response/place-zero-order-direct",

    // PROVIDER SERVICE PURCHASE APIs
    PROVIDER_CHECKOUT_V1: "/wp-json/provider/v1/checkout/",
    PROVIDER_CHECKOUT: "/wp-json/provider/v2/checkout/",
    PROVIDER_PLACEORDER: "/wp-json/provider/v1/placeorder/",
    SUBSCRIPTION_CANCEL: "/wp-json/xsel/v1/subscription-cancel",

    SESSION_LIST_DATA: "/wp-json/products/session-list",
    CALENDAR_SESSIONS_DATA: "/wp-json/products/get-my-session-list",
    CALENDAR_SESSIONS_BROKER_DATA:
      "/wp-json/xsel/v1/get-my-session-list-broker",
    CALENDAR_HOST_SESSIONS_DATA: "/wp-json/xsel/v1/host-assigned-sessions",
    CALENDAR_INSTRUCTOR_SESSIONS_DATA:
      "/wp-json/xsel/v1/instructor-assigned-sessions",
    // CALENDAR_SESSION_ECOM_LIST: "/wp-json/session/all-list",
    CALENDAR_SESSION_ECOM_LIST: "/wp-json/xsel/v1/calendar-sessions",
    CALENDAR_SESSION_BROKER_LIST: "/wp-json/xsel/v1/all-session-list",
    CALENDAR_BOARDCAST_DATA: "/wp-json/xsel/v1/get-eventsession-details",

    //Live Sessions
    LIVE_SESSION_DATA: "/wp-json/xsel/v1/live-sessions",

    //Smart Bar

    GET_SMART_BAR: "/wp-json/xsel/v1/get-header-prompt",

    //Free Videos
    FREE_VIDEOS: "/wp-json/xsel/v1/most-watched-free-videos",

    GET_GOOGLE_SYNC: "/wp-json/calendar-invite/v1/google-sync",
    MY_TEAM_LIST: "/wp-json/xsel/v1/my-team-list",
    SHARE_IMAGE_LEADER_BOARD: "wp-json/xsel/leader-board-share",

    // Coupon Code
    COUPON_CODE_APPLY: "/wp-json/woocommerce/v1/apply-coupon-code",

    //News letter
    NEWSLETTERSUBSCRIPTION: "/wp-json/xsel/v1/add-subscriber",

    // XSel Points
    GET_CREDIT_POINTS: "/wp-json/woocommerce/v1/get-credit-points",

    ORDER_HISTORY_BASE_PATH: "/wp-json/order/my-order",
    SUBSCRIPTION_DATA: "/wp-json/order/my-subscription",
    GET_COURSE_LIST_WOO_BASE_PATH: "/wp-json/products/get-products",
    GET_ORDER_DETAIL_BASE_PATH: "/wp-json/order/single-order/",

    GET_ALL_LEARNING_PATH: "/wp-json/xsel/v1/get-all-learning-path",
    SHOW_LEARNING_POINTS: "/wp-json/learning-points/points",
    GET_CREDIT_POINTS_HISTORY:
      "/wp-json/woocommerce/v1/get-credit-points-history",

    EVENT_LIST: "/wp-json/events/events-list",
    ECOM_EVENT_LIST: "/wp-json/event/list-data",
    EVENT_DETAIL: "/wp-json/events/single-event",
    ECOM_EVENT_DETAIL: "/wp-json/event/details",
    SESSION_LIST_BROKER: "/wp-json/xsel/v1/get_event_sessions",
    ENROLL_SESSION_BROKER: "/wp-json/xsel/v1/session-registration", //"/wp-json/xsel/v1/register-broker-event",
    CHECK_SESSION_ENROLL_AVAILABILITY: "/wp-json/xsel/v1/seat_availability",
    IN_PROGRESS_BROKER: "/wp-json/xsel/v1/in-progress-courses",
    EVENT_NOTIFICATION: "/wp-json/xsel/v1/event-notification",
    CHECK_NOTIFIED: "/wp-json/xsel/v1/fetch-notified-event",
    CANCEL_SESSION: "/wp-json/xsel/v1/session-cancel",
    CERTIFICATE_SESSION_LIST: "/wp-json/event/certificate-list",

    // Assigned
    ASSIGNED_COURSES: "/wp-json/assign_handler/v1/assign_data",
    VIEW_MARK: "/wp-json/xsel/v1/add-entity-record",

    // Check Content
    CHECK_CONTENT_ACCESS: "/wp-json/broker-xsel/v1/check-content",

    // WOOCOMMERCE
    MY_COURSES_ECOM: "/wp-json/woocommerce/v1/my-courses",

    // Broker
    MY_COURSES_BROKER: "/wp-json/xsel/v1/my-courses",
    GET_CERTIFICATES: "/wp-json/learning-path/certificates/",
    GET_BADGES: "/wp-json/courses/badges/",
    GET_MY_LEARNING_PATHS: "/wp-json/xsel/v1/my-learningpaths",
    GET_MY_LEARNING_PATHS_ECOM: "/wp-json/xsel/v1/lp-details",
    GET_BUNDLE_DETAIL: "/wp-json/xsel/v1/bundle-details",
    SINGLE_LP: "/wp-json/xsel/v1/learningpaths-details",
    // code of ethics
    MASTER_CODE_OF_ETHICS: "/wp-json/check/list",
    MASTER_CODE_OF_ETHICS_AGREE: "/wp-json/checklist/response",

    // Host
    CREATE_ZOOM_MEETING: "/wp-json/zoom/v2/zoom-create-meeting",

    // Join ZOOM
    JOIN_ZOOM_MEETING: "/wp-json/zoom/v2/add-zoom-participant",

    ADD_TO_WISHLIST: "/wp-json/shopping/addwishlist",
    SAVE_BOOKMARKS: "/wp-json/xsel/v2/save-bookmarks",
    GET_WISHLIST: "/wp-json/shopping/show-addwishlist",
    DEL_WISHLIST: "/wp-json/cart/remove-wishlist",
    GET_LICENSED_AS: "/wp-json/xsel/v1/fetch-licensed-as",
    GET_SEARCH_DATA: "/wp-json/xsel/v1/global-search",
    GET_SEARCH_DATA_WOO: "/wp-json/search/term",

    // Video Listing
    VIDEO_LISTING: "/wp-json/products/videos-list",

    // Membership
    MEMBERSHIP_DETAILS: "/wp-json/woocommerce/membership/info",
    MEMBERSHIP_INTENT: "/wp-json/woocommerce/membership/payment-intent",
    MEMBERSHIP_PAYMENT_CHECKOUT:
      "/wp-json/woocommerce/membership/checkout-response",

    //Role requested
    ROLE_REQUESTED: "/wp-json/designation/list",
    ACCEPT_ROLE_REQUESTED: "/wp-json/userstatus/response",
    ACCEPT_ALL_ROLE_REQUESTED: "/wp-json/mentors/responseall",
    USER_LIST_OF_ROLE_ACCEPTED: "/wp-json/xsel/v1/realtor-list-data",
    USER_LIST_OF_ROLE_ACCEPTED_SEARCH: "/wp-json/xsel/v1/realtor-search-data",
    USER_LIST_OF_ROLE_CANCEL: "/wp-json/designation/cancel",
    USER_ROLE_REQUEST_STATUS: "/wp-json/designation/state",
    ADD_MODULE_PROGRESS: "/wp-json/xsel/add-module-progress",
    REC_IDS_API: "/wp-json/finwell/v1/save-recommended-ids",
    SAVE_ANSWERS: "/wp-json/xsel/v1/save-assessment-responses",
    ASSIGN_ROLEPLAY: "/wp-json/assign-handler/v1/self-assign-roleplay",

    TIMEZONE: "/wp-json/xsel/v1/get-timezone",
    TIMEZONE_ABBR: "/wp-json/xsel/v1/get-timezone-abbr",

    ACCESSCODE: "/wp-json/xsel/v1/add-guest-user/",

    //SHARE_IMAGE

    SHARE_IMAGE: "/wp-json/xsel/marketing-calendar-share",

    //Provider

    PROVIDER_LIST: "/wp-json/provider/list",
    PROVIDER_ENTITY_TYPE_DETAILS:
      "/wp-json/provider/provider-entity-type-details",
    PROVIDER_CATEGORY: "/wp-json/xsel/provider/provider-category",
    PROVIDER_DETAIL: "api/provider_details",
    PROVIDER_VIDEO_CATEGORY: "/wp-json/subcategories/video-categories-data",
    PROVIDER_COACHING: "/wp-json/xsel/provider/service",
    MY_PROVIDER_COACHING: "/wp-json/xsel/provider/my-services",

    MY_EVENTS_ECOM: "/wp-json/event/my-event-data",
    MY_EVENTS_BROKER: "/wp-json/events/my-events",

    // Recommendations
    RECOMMENDATION_RESPONSE: "/wp-json/product/recommendation-purchase",

    // Recommendation View :
    RECOMMENDATION_VIEW_RESPONSE: "/wp-json/product/recommendation-view",

    // Recommendation Insert View :
    RECOMMENDATION_INSERT_VIEW_RESPONSE:
      "/wp-json/product/recommendation-insert-view",

    // Certificates and Badges Generation :
    CERTIFICATE_DATA_RESPONSE: "/wp-json/xsel/generate-certificate-badge",
    // CERTIFICATE_LIST: "/wp-json/xsel/v1/certificate-details",

    // Notifications :
    NOTIFICATION_RESPONSE: "/wp-json/user/show-notifications",

    // Notifications Count:
    NOTIFICATION_COUNT_RESPONSE: "/wp-json/user/notification-count",

    // report apis endpoint
    PROFILE_REPORT: "/wp-json/xsel/report/user-report",
    COURSE_REPORT: "/wp-json/xsel/report/course-report",
    EVENT_REPORT: "/wp-json/user/event-reports",
    PLAN_UPGRADE_REPORT: "/wp-json/woocommerce/report/get-upgrade-report",
    PURCHASE_REPORT: "/wp-json/woocommerce/report/get-purchase-report",
    VIDEO_DETAIL: "/wp-json/products/videos-detail",
    OFFICE_LIST: "/wp-json/xsel/v1/office-list",
    CODE_OF_ETHICS_REPORT: "/wp-json/report/coe-list-report",
    CODE_OF_ETHICS_REPORT_REA: "/wp-json/report/coe-reas",
    CODE_OF_ETHICS_REPORT_MANAGERS: "/wp-json/report/coe-managers-list",
    CODE_OF_ETHICS_REPORT_OFFICES: "/wp-json/report/coe-offices",
    CODE_OF_ETHICS_REPORT_TREND: "/wp-json/report/coe-trend",
    LEARNING_PATH_TABLE: "/wp-json/xsel/report/lp-list-report",
    LEARNING_PATH_REA: "/wp-json/xsel/report/lp-reas",
    LEARNING_PATH_MANAGERS: "/wp-json/xsel/report/lp-managers-list",
    LEARNING_PATH_OFFICES: "/wp-json/xsel/report/lp-offices",
    LEARNING_PATH_TREND: "/wp-json/xsel/report/lp-completion-trend",
    LEARNING_PATH_STATS: "/wp-json/xsel/report/lp-stats",
    ONBOARDING_REPORT: "/wp-json/xsel/report/onboarding-list-report",
    ONBOARDING_REA: "/wp-json/xsel/report/oblp-reas",
    ONBOARDING_MANAGERS: "/wp-json/xsel/report/oblp-managers",
    ONBOARDING_OFFICES: "/wp-json/xsel/report/oblp-offices",
    ONBOARDING_TREND: "/wp-json/xsel/report/oblp-completion-trend",
    ONBOARDING_STATS: "/wp-json/xsel/report/oblp-stats",
    COURSE_REPORT_REA: "/wp-json/xsel/report/course-reas",
    COURSE_REPORT_MANAGERS: "/wp-json/xsel/report/course-manager-list",
    COURSE_REPORT_STATS: "/wp-json/xsel/v1/course-stats",
    COURSE_REPORT_COMPLETION_TREND:
      "/wp-json/xsel/report/courses-completion-trend",
    COURSE_REPORT_COMPLETION_OFFICES: "/wp-json/xsel/report/course-offices",
    USAGE_REPORT: "/wp-json/xsel/report/usage-report",
    ASSESSMENT_RESPONSE_REPORT: "/wp-json/xsel/v1/assessment-response-report",

    // Role Play
    RECORD_ROLEPLAY_DETAIL_API: "/wp-json/roleplay/recorded/detail/",
    PARTICIPATE_ROLEPLAY: "/wp-json/xsel/roleplay",
    REVIEW_ROLEPLAY_LIST: "/wp-json/review/list",
    REVIEW_FILTER_ROLEPLAY_LIST: "/wp-json/roleplay/review/list",
    SUBMIT_FEEDBACK: "/wp-json/xsel/review",
    MY_ROLEPLAY_LIST: "/wp-json/xsel/roleplay/my-roleplay", ///wp-json/myroleplay/list
    RELATED_VIDEO_LIST: "/wp-json/myroleplay/related/list",
    MY_ROLEPLAY_FILTER_LIST: "/wp-json/myroleplay/recording/list",
    FETCH_ROLEPLAY_ASSIGNMENT_WISE: "/wp-json/woocommerce/list-role-play",
    PRODUCT_CATEGORIES_DATA: "/wp-json/subcategories/product-categories-data",
    PRODUCT_COMBO_DATA: "/wp-json/xsel/v1/get-bundle-add-offer-product",
    PRODUCT_CATEGORIES_DATA_MY_COURSE: "/wp-json/xsel/v1/my-course",
    PRODUCT_CATEGORIES_DATA_RECOMMEND: "/wp-json/asset/action/recommedation",
    PRODUCT_SUB_CATEGORIES_DATA:
      "/wp-json/subcategories/product-sub-categories",
    VIDEO_LISTING_DATA_BY_CAT: "/wp-json/subcategories/video-categories-data",
    VIDEO_LISTING_DATA_BY_SUB_CAT:
      "/wp-json/subcategories/video-sub-categories",
    VIDEO_LISTING_DATA_RELATED: "/wp-json/categories/related-video-categories",
    COURSE_RELATED: "/wp-json/categories/course-navigation-api",
    ASSIGNED_USER: "/wp-json/assign-handler/v1/list-assignment-view",
    DUE_DATE_ASSIGNED_USER: "/wp-json/xsel/v1/update-due-date",
    EVENT_TYPE_LIST: "/wp-json/events/xsel-event-type",

    IS_AGGREE: "/wp-json/xsel/v1/terms-condition-consent",
    GET_POST_LIST: "/wp-json/xsel/network/activity-list-api",
    GET_ADD_COMMENTS: "/wp-json/xsel/network/add-comments",
    GET_EDIT_COMMENTS: "/wp-json/xsel/network/edit-comments",
    GET_LIKE_COMMENT: "/wp-json/xsel/network/comments-like",
    GET_ACTIVITY_LIKE: "/wp-json/xsel/network/activity-like",
    GET_PRIVACY_CONTENT: "/wp-json/xsel/v1/get-terms-condition-content",
    GET_LEADERBOARD: "/wp-json/leader/board",
    GET_USER_POINTS: "/wp-json/lp/points",

    MY_VIDEO_ECOM: "/wp-json/products/my-videos-list",

    GET_BRANDING_INFO: "/wp-json/xsel/v1/get-branding-data",
    CERTIFICATE_LIST: "/wp-json/events/events-list",
    SINGLE_CERTIFICATION: "/wp-json/products/session-list",
    GET_MY_EVENTS: "/wp-json/events/my-events",
    SAVE_FILTER_DATA: "/wp-json/xsel/v1/filter-save-data",
    GET_SAVED_FILTER_DATA: "/wp-json/xsel/v1/get-save-filter-data",
    GET_SAVED_FILTER_DATA_BY_ID: "/wp-json/xsel/v1/get-save-filter-by-id",
    DELETE_SAVED_FILTERS: "/wp-json/xsel/v1/delete-filter-data",
    EVENTS_REGISTERATION_CONTACT: "/wp-json/xsel/v1/brokerage-mail",
    GET_UPCOMING_COURSES: "/wp-json/v1/xsel/upcoming-course-list",
    GET_UPCOMING_VIDEOS: "/wp-json/v1/xsel/upcoming-video-list",
    ABOUT_US: "/wp-json/wp/v2/pages?slug=about-us",
    CONTACT_US: "/wp-json/wp/v2/pages?slug=contact-us",
    HELP_US: "/wp-json/wp/v2/pages?slug=help-us",
    ROLEPLAY_DRAFT_DELETE: "/wp-json/myroleplay/draft/delete",
    ROLEPLAY_DRAFT_SUBMIT: "/wp-json/myroleplay/draft/submit",
    REMIND_USER_REPORT_REQ: "/wp-json/xsel/v1/save-report-notification",
    ORDER_DETAIL_PATH: "/wp-json/order/order-detail",
    TAGS_LISTING: "/wp-json/xsel/v1/tag-listing",
    NEW_CONTENT_COUNT: "/wp-json/xsel/v1/menu",
    NEW_EVENTS_TAB: "/wp-json/xsel/v1/new-event-list",
    COACHING_NOTES_LIST: "/wp-json/xsel/v1/coaching-list",
    ADD_COACHING_NOTES_LIST: "/wp-json/xsel/v1/coaching-save",
    EDIT_COACHING_NOTES_LIST: "/wp-json/xsel/v1/coaching-update",
    DELETE_COACH: "/wp-json/xsel/v1/coaching-delete",
    GET_RANK_STATUS: "/wp-json/leader/get-user-current-rank",
    SIMILAR_PRODUCTS_LIST: "/wp-json/xsel/v2/similar-product-list",
    REMOVE_WISHLIST: "/wp-json/shopping/remove-wishlist",
    DYNAMIC_TEXT: "/wp-json/xsel/v1/xsel-static-content",
    IMPERSONATE_USER: "/wp-json/api/impersonate",
    CS_GETSKILLS: "/wp-json/v1/get-skill",
    SUBMIT_SKILLS: "/wp-json/xsel/provider/service",
    ADD_GROUP_WORKSHOP: "ADD_GROUP_WORKSHOP",
    TRAINERS_LIST: "/wp-json/xsel/v1/instructor-list",
    MEMBERS_LIST: "/wp-json/xsel/v1/my-team-list",
    WORKSHOP_SUBMIT: "/wp-json/xsel/v1/add-group-workshop",
    UPDATE_GROUP_WORKSHOP: "/wp-json/xsel/v1/update-workshop",
    GET_CITY: "wp-json/xsel/v1/get-city",
    GET_SLOTS: "/wp-json/xsel/v1/get-slots",
    CREATE_SLOTS: "/wp-json/xsel/v1/add-slots",
    ADD_SLOTS: "/wp-json/xsel/v1/create-slots",
    DELETE_SLOTS: "/wp-json/xsel/v1/delete-slot",
    GET_SESSION_NOTES: "/wp-json/coaching/session-notes",
    GET_SESSION_NOTES_LIST: "/wp-json/coaching/session-notes-list",
    ADD_SESSION_NOTES: "/wp-json/coaching/add-session-notes",
    COACH_RATING: "/wp-json/xsel/v1/add-rating",
    GET_LANGUAGES: "/wp-json/xsel/v1/get-language",
    GET_FEEDBACK_RATING: "/wp-json/xsel/v1/get-rating",
    MASTER_INDUSTRY_DATA: "/wp-json/v1/coaching/service/industry/master",
    COACHING_SERIVICES_LISTING: "/wp-json/v1/coaching/service/listing",
    COACHING_SERVICE_DETAIL: "/wp-json/xsel/v1/coaching/service/detail",
    COACHING_REQUEST_SEND: "/wp-json/coaching/request-send",
    COACHING_REQUESTS_LIST: "/wp-json/coaching/coaching-request-list",
    COACHING_REQUEST_UPDATE: "/wp-json/coaching/coaching-request-update",
    AI_COACHING_TOKEN: "/wp-json/roleplay/v1/get-token",
    SCHEDULED_SESSIONS: "/wp-json/xsel/v1/get-scheduled-session-callsheet",
  },
  API_ROUTES_REAL_BROKER: {
    REAL_BROKER_BASE_PATH: "/wp-admin/admin-ajax.php?",
    REAL_BROKER_UPLOAD_IMAGE_PATH: "wp-json/xsel/v1/update-profile-picture",
    REAL_BROKER_UPDATE_PROFILE: "wp-json/xsel/v1/update-profile",
    REAL_BROKER_SEARCH_USER: "wp-json/xsel/v1/search-user",
    REAL_BROKER_GET_BANNER: "wp-json/xsel/v1/get-broker-banner",
    BROKER_ADMIN_VIDEO_DETAIL: "wp-json/myvideo/details",
    REAL_BROKER_UPLOAD_POST: "wp-json/xsel/network/create-activity",
    // Video Listing- Broker admin
    BROKER_ADMIN_VIDEO_LIST: "wp-json/video/list",
    BROKER_ADMIN_VIDEO_COMPLETION: "wp-json/video/video-completion-lp",
    OVERALL_SUMMARY_LEARNING_DATA: "wp-json/report/lp-points",
    OVERALL_DATA_RESPONSE: "wp-json/report/user-lp",
    OVERALL_SUMMARY_LEARNING_GRAPH: "wp-json/report/lp-graph",
    GET_TEAMMATES_LIST: "wp-json/assign-handler/v1/get-manager-rea",
    ASSIGN_TEAMMATES: "wp-json/assign-handler/v1/create-team-teammates",
    CREATE_TEAM_BY_TEAMMATES: "wp-json/assign-handler/v1/create-agent-teams",
    GET_OFFICE_LIST: "wp-json/assign-handler/v1/get-office-list",
    GET_COMPLETED_COURSE_LIST:
      "wp-json/assign-handler/v1/get-completed-course-list",
    GET_USER_BY_FILTER: "wp-json/assign-handler/v1/get-users-by-filter",
    GET_TEAMS_LIST: "wp-json/assign-handler/v1/get-team-list",
    GET_DEFAULT_TEAMS_LIST: "wp-json/assign-handler/v1/default-teams-list",
    ASSIGN_TO_TEAMS: "wp-json/assign-handler/v1/assign-course-by-teams",
    COURSE_COMPLETION_TREND: "wp-json/lp/completion-trend",
    COMPLIANCE_COMPLETION_TREND: "wp-json/lp/compliance-trend",
    COMPLIANCE_REPORT: "/wp-json/report/compliance-report",
    GET_ASSIGNED_USERS:
      "wp-json/assign-handler/v1/get-assigned-users-teams-list",
    GET_MANAGER_COACH_MENTOR: "wp-json/report/managers-list",
    CHOOSE_COURSE: "wp-json/xsel/v1/fetch-all-courses-for-reports",
    CHOOSE_ACTION_PATH: "wp-json/xsel/v1/get-action-pasth-list",
    CHOOSE_PROVIDER: "wp-json/report/provider",
    GET_LEVEL_DETAIL: "wp-json/xsel/v1/get-all-level-course",
    DEL_COMMENT: "wp-json/xsel/network/delete-comments",
    DEL_POST: "wp-json/xsel/network/delete-activity",
    EDIT_POST: "wp-json/xsel/network/update-activity",
    CHOOSE_LP_PATH_FILTER: "wp-json/xsel/v1/fetch-all-lps-for-reports",
    MY_VIDEO_BROKER: "wp-json/video/my-video",
    CREATE_FOLDER: "wp-json/xsel/v1/create-toolbox-folder",
    CREATE_FILE: "wp-json/xsel/v1/toolbox-files",
    DELETE_FOLDER: "wp-json/xsel/v1/toolbox-remove-folder",
    DELETE_FILE: "wp-json/xsel/v1/toolbox-remove-file",
    FOLDER_DETAILS: "wp-json/xsel/v1/toolbox-folder-detail",
    SEARCH_DETAILS: "wp-json/xsel/v1/toolbox-search",
    CHECKLIST_DETAIL: "wp-json/xsel/v1/get-checklist-manager-list",
    CHECKLIST_APPROVAL: "wp-json/xsel/v1/save-checklist-review-status",
    TOOLBOX_UPDATE_TIME: "wp-json/xsel/v1/toolbox-time",
    CHECKLIST_INSERT: "wp-json/xsel/v1/insert-checklist",
    CHANGE_PASSWORD: "wp-json/xsel/v1/rea-change-password",

    PROVINCE_MASTER: "wp-json/xsel/v1/province",
    TOUR_AND_GUIDE_COMPLETE: "wp-json/xsel/v1/tour-guide",
    GET_USER_DETAIL_OTHER: "wp-json/xsel/report/user-details",
    GET_BRAND_THEME: "wp-json/xsel/v1/get-brand",
    GET_EMAIL_VERIFY: "wp-json/xsel/v1/email-verification-for-sso",
    ACTIVATE_SOCIAL_EMAIL: "wp-json/xsel/v1/user-activation",
    COVER_PHOTO: "/wp-json/xsel/v1/update-cover-image",
    UPLOAD_ON_AWS: "/wp-json/v1/upload-on-aws",
    GET_SLOTS: "/wp-json/xsel/v1/get-slots",
    SAVE_LEADERBOARD: "/wp-json/leaderboard/save-exclude-users",
    REGISTER_AS_A_COACH: "/wp-json/v1/register-coach",
    WORKSHOP_TIMEZONE: "wp-json/xsel/v1/get-timezone",
    DELETE_TEAM: "wp-json/teams/v1/delete-teams",
    ACTIVITY_LOG: "wp-json/xsel/v1/activity-ring",
  },
  BROKER_API: {
    LOGIN_LOGO_URL: "/wp-json/xsel/v1/get-broker-info",

    CHECK_EMAIL_EXISTS: "wp-json/xsel/v1/check-email-exists",
    GET_MY_LP_LISTING: "/wp-json/xsel/v1/my-lp-listing",
    GET_ALL_LP_LISTING: "/wp-json/xsel/v1/lp-listing",

    // DISCUSS API
    FETCH_COMMENT_BY_ENTITY_ID: "wp-json/comment/list",
    POST_COMMENT_BY_ENTITY_ID: "wp-json/comment/add",
    LIKE_DISLIKE_COMMENT: "wp-json/comment/reaction",

    //Signup api
    SIGNUP_API_URL: "wp-json/xsel/v1/user-signup",
    OTP_API_URL: "wp-json/xsel/v1/user-verify-token",
    RESEND_OTP_API_URL: "wp-json/xsel/v1/user-resend-verify-token",

    // ROLEPLAY
    GET_XSEL_ROLEPLAY_MASTER_LIST: "/wp-json/xsel/roleplay/list",

    //Popular Courses
    GET_POPULAR_COURSES: "/wp-json/xsel/v1/popular-entity",

    //Popular Free Courses

    GET_POPULAR_FREE_COURSES: "/wp-json/xsel/v1/popular-free-courses",

    //courses included with paid subscription
    GET_COURSES_INCLUDED_WITH_PAID_SUBSCRIPTION:
      "/wp-json/xsel/v1/courses-included-with-subscription",

    GET_LP_INCLUDED_WITH_SUBSCRIPTION:
      "/wp-json/xsel/v1/lp-included-with-subscription",

    //courses included with Higher subscription
    GET_COURSES_INCLUDED_WITH_HIGHER_SUBSCRIPTION:
      "/wp-json/xsel/v1/course-list-higher",

    GET_CATEGORY_LIST_NEW_END_POINT: "/wp-json/xsel/v1/categories-listing",
    GET_CATEGORY_LIST_NEW_END_POINT1: "/wp-json/xsel/v1/categories-listing-api",
    GET_SUB_CATEGORY_LIST_NEW_END_POINT:
      "/wp-json/xsel/v1/sub-categories-listing-api",

    GET_COACHING_DETAILS: "/wp-json/xsel/v1/coaching-detail",

    GET_TESTIMONAL_DATA: "/wp-json/xsel/v1/get-testimonials",

    GET_POPULAR_CERTIFICATES: "/wp-json/events/popular-certifications",
    //Calculators
    GET_CALC_DATA: "/wp-json/xsel/v1/product-categories-calculator-data",

    //Useful COurses
    GET_USEFUL_COURSES: "/wp-json/xsel/v1/useful-entity",
    LIKE_DISLIKE_PRODUCT: "/wp-json/xsel/v1/like-activity",

    GET_GLOBAL_SEARCH_COURSES: "/wp-json/xsel/v1/gs-course",
    GET_GLOBAL_SEARCH_VIDEOS: "/wp-json/xsel/v1/gs-video",
    GET_GLOBAL_SEARCH_EVENTS: "/wp-json/xsel/v1/gs-events",
    GET_GLOBAL_SEARCH_LP: "/wp-json/xsel/v1/gs-lp",
    GET_GLOBAL_SEARCH_COURSE: "/wp-json/xsel/v1/gs-course",
    GET_GLOBAL_SEARCH_PARTNERS: "/wp-json/xsel/v1/gs-partners",
    GET_GLOBAL_SEARCH_COACHINGS: "/wp-json/xsel/v1/gs-coaching",
    GET_GLOBAL_SEARCH_CERTIFICATIONS: "/wp-json/xsel/v1/gs-certifications",

    // REPORT
    LEARNING_PATH_TABLE: "/wp-json/xsel/report/lp-list-report",
    COURSE_REPORT: "/wp-json/xsel/report/course-report",
    BROKERAGE_FILTER: "/wp-json/v1/filter/brokerage-list",

    // GROUP WORKSHOP
    GET_WORKSHOP_DETAIL: "/wp-json/xsel/v1/get-workshop-details",
    UPDATE_WORKSHOP_DETAIL: "/wp-json/xsel/v1/update-group-workshop",
  },
  ECOM_API: {
    SYNC_LOCAL_CART: "/wp-json/xsel/v1/sync-cart",

    COURSE_DETAIL_ECOM: "/wp-json/xsel/v1/course-details",

    GET_CATEGORY_BY_ENTITY_ID: "/wp-json/xsel/v1/entity-category-list",
    GET_VIDEO_LISTING: "/wp-json/xsel/b2c-video-list",
    MY_VIDEO_LISTING: "/wp-json/xsel/b2c-my-video-list",

    ALL_VIDEO_LISTING: "/wp-json/xsel/video-listing",
    GET_AVAILABLE_LP_BY_ENTITY_ID: "/wp-json/xsel/v1/get-learning-path-data",

    // ROLEPLAY
    GET_ROLEPLAY_DETAIL: "/wp-json/woocommerce/role-play-detail",

    // SUBSCRIPTION
    GET_SUBSCRIPTION_PLAN: "wp-json/xsel/v1/get-subscription-plan",
    GET_SUBSCRIPTION_PI: "wp-json/subscription/v1/checkout",
    CHANGE_SUBSCRIPTION_TO_BASIC: "/wp-json/subscription/v1/change",
    MEMBERSHIP_PAYMENT_UPDATE: "wp-json/subscription/v1/payment-update",
    GET_SUBSCRIBED_DATA: "/wp-json/subscription/v1/subscribed",
    GET_SUBSCRIBED_RECEIPT: "/wp-json/subscription/v1/view/receipt",

    // PROVIDER SUBSCRIPTION
    PROVIDER_CHECKOUT: "/wp-json/provider/v2/checkout/",
    PROVIDER_PLACEORDER: "/wp-json/provider/v2/placeorder/",

    // PAYMENT
    GET_CARD_INFO: "/wp-json/payment/method/v1/customer",
    UPDATE_PAYMENT_DETAIL: "/wp-json/payment/method/v1/customer/update",
    PRODUCT_PAYMENT_CHECKOUT: "/wp-json/checkout/user",

    // HALIFAX COACHING LISTING
    GET_COACHING_LISINT: "wp-json/v1/coaching/listing",
    PERSONAL_COACHING_LISTING: "/wp-json/v1/coaching/personal/listing",

    // MY BOOKING LISTING
    MY_COACHING_BOOKING_LIST: "/wp-json/v1/coaching/bookings/listing",
  },
  SESSION_EXPIRED_URL: window.location.origin,
};

export default API_LIST;
